/*
 * @Author: cc
 * @Date: 2020-12-31 14:09:00
 * @LastEditTime: 2022-01-20 15:00:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\shortVideo\newDraft.js
 * @Description: 短视频模块新建稿件
 */

'use strict';
angular.module('editShortVideoNewDraftModule', []).controller('EditShortVideoNewDraftCtrl', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'newMediaService',
    'editCenUploadVideoForXjService',
    // 'trillConst',
    'editIsLock',
    'noticeWindowService',
    'messagePublishService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        newMediaService,
        editCenUploadVideoForXjService,
        // trillConst,
        editIsLock,
        noticeWindowService,
        messagePublishService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                // 判断是否显示校验
                showCheckList: [false, false],
                support: {
                    content: '',
                },
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                isFusionEditor: $state.current.name === 'fusionvideo', // 是否来自融合编辑器
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                emojiShow: false,
            };
            $scope.data = {
                originList: [
                    {
                        name: '内部原创',
                        value: '2',
                    },
                    {
                        name: '整合原创',
                        value: '1',
                    },
                    {
                        name: '特约稿',
                        value: '3',
                    },
                    {
                        name: '通讯员稿',
                        value: '4',
                    },
                    {
                        name: '报道组稿',
                        value: '5',
                    },
                    {
                        name: '其他',
                        value: '6',
                    },
                ],
                version: [], // 流程展示数据
                copyVersion: [],
                topicList: [],
                titleWordNum: 0,
                baiduLocation: {
                    placeName: '',
                    lng: '',
                    lat: '',
                    city: '',
                    title: '',
                    poiId: '',
                },
                strogeKey: 'DraftChange', // 为了后面统一缓存，减少代码量，先添加字段做区分
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = angular.extend($scope.status, $scope.trenchStatus);
            $scope.data = angular.extend($scope.data, $scope.trenchData);
        }

        /** **************************适应融合编辑器切换渠道开始**************************/
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if ($scope.status.meteDataId) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/
        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                ($scope.status.meteDataId ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            // initArrayBtn();
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData description]初始化新稿件
         * @param   {[fun]}  dealWithListFun   [dealWithListFun description]融合编辑传入的方法
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                methodName: 'save',
                TITLE: '',
                VAPPENDIX: '',
                VAPPENDIXNAME: '',
                description: '',
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                ORIGINAL: 0,
                SPECIALDOC: 0,
                VIDEOREL: [],
            };
            $scope.list = angular.extend($scope.list, $scope.trenchList); // 合并渠道下的list
            // 融合编辑器下转码list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            initOrigin();
            loadDirective().then(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initEditData description]初始已保存的稿件
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]融合编辑传入的方法
         * @return  {[type]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = $scope.trenchDraftParams;
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    // serviceid: 'mlf_fusiontiktok',
                    // methodname: 'getTikTokVirtualDoc',
                    SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
                params = angular.extend(params, $scope.trenchFusionEditorParams);
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                dealEditTitle();
                $scope.list.serviceid = $scope.data.trenchConst.serviceidKey;
                $scope.list.methodName = 'save';
                $scope.list.CONTENT = $scope.list.CONTENT || $scope.list.DESCRIPTION;
                $scope.list.accountId = $state.params.accountid;
                loadDirective();
                initOrigin();
                showVersion();
                initLocation();
                // 融合编辑下转码list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                defer.resolve();
            });
            //  稿件加锁
            editIsLock.lockDraft($scope.status.meteDataId);
            return defer.promise;
        }

        /**
         * [dealEditTitle description] 处理回显的标题
         * @return  {[type]}  [return description]
         */
        function dealEditTitle() {
            $scope.data.topicList = [];
            $scope.data.titleWordNum = $scope.list.TITLE.length;
            let arr = $scope.list.TITLE.split(' ');
            angular.forEach(arr, function (item) {
                if (isTopic(item)) {
                    let title = item.split('#')[1];
                    let topic = {
                        id: 'dy_topic' + $scope.data.topicList.length + 1,
                        title: title,
                    };
                    $scope.data.topicList.push(topic);
                    $scope.list.TITLE = $scope.list.TITLE.replace(item + ' ', '');
                }
            });
        }

        /**
         * [isTopic description] 判断是否是话题
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function isTopic(item) {
            let reg = /#[^#]*/gi;
            return reg.test(item);
        }

        /**
         * [loadDirective description]动态加载指令
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            var videoUpload =
                '<div trs-upload-for-xj-video-draft list="list" storage-type="trill" metadata="' + $scope.status.routerArticleIdKey + '" limit-obj="videolimit" original-limit-obj="originalLimitObj"></div>';
            videoUpload = $compile(videoUpload)($scope);
            $element.find('videocon').append(videoUpload);
            if (!$state.params.issave || $state.params.issave === '0') {
                var draftList =
                    '<editor-dir list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="videoForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0" mark></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
                defer.resolve();
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /* 稿件操作开始*/
        /**
         * [examineVideo description] 检查视频
         * @return  {[type]}  [return description]
         */
        function examineVideo() {
            var defer = $q.defer();
            var info;
            // if ($scope.list.VIDEOREL[0].fmt && $scope.list.VIDEOREL[0].fmt !== 'mp4') {
            //     info = '请选择mp4类型的视频';
            // }
            if ($scope.list.VIDEOREL[0].resourcesize && $scope.list.VIDEOREL[0].resourcesize > $scope.videolimit.size * 1024 * 1024) { // 云视返回的是byte
                info = '请选择' + $scope.videolimit.size + 'M以内的视频';
            }
            if ($scope.list.VIDEOREL[0].resourceduration && $scope.list.VIDEOREL[0].resourceduration > $scope.videolimit.duration * 60 * 1000) { // 云视返回的是ms
                info = '请选择' + $scope.videolimit.duration + '分钟以内的视频';
            }
            if (info) {
                modalDialog.alertType('保存失败', info, 'warning', false);
                defer.reject();
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            saveList(true).then(
                function () {
                    $scope.status.isEditDraft = true;
                    storageListenerService.addListenerToDraftChange();
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    showVersion();
                    // 保存
                    if (!$scope.status.isFusionEditor) {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }
                    defer.resolve();
                },
                function (msg) {
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    defer.reject(msg);
                }
            );

            return defer.promise;
        };


        /**
         * [saveList description]切换时保存list数据
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果页面直接关闭则不进行改操作
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            editCenUploadVideoForXjService.exampleVideoBeforeSave($scope).then(() => {
                examineVideo().then(() => {
                    // 转码发稿单作者信息空数据提交问题
                    if ($scope.status.isFusionEditor) {
                        $scope.list.serviceid = 'mlf_fusiontiktok';
                        $scope.list.methodName = 'saveTikTokVirtualDoc';
                        $scope.list.SourceDocId = $scope.data.sourceDocId || $scope.status.meteDataId;
                        $scope.list.FusionTikTokId = $scope.status.meteDataId || '0';
                        $scope.list.CONTENT = '抖音';
                    }
                    $scope.videoForm.$pending = {};
                    $validation
                        .validate($scope.videoForm)
                        .success(function () {
                            modalDialog.isSecretInformation(
                                true,
                                function () {
                                    dealTitle();
                                    var list = jsonArrayToStringService.jsonArrayToString(angular.copy($scope.list));
                                    list.DESCRIPTION = $scope.list.CONTENT;
                                    list.SPECIALDOC = $scope.data.specialDoc;
                                    list.ORIGINALTYPE = $scope.data.originType;
                                    // list.DOUYINARTICLEID = $scope.status.meteDataId || 0;
                                    list[$scope.status.articleIdKey] = $scope.status.meteDataId || 0;
                                    list.POI_NAME = $scope.data.baiduLocation.placeName;
                                    list.POI_ID = $scope.data.baiduLocation.poiId;
                                    $scope.videoForm.$setPristine();
                                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                        $scope.refreshParams(data); // 保存成功后需要刷新一下参数
                                        $scope.status.meteDataId = $scope.list[$scope.status.articleIdKey] = data.METADATAID.replace(/\"/g, '');
                                        dealEditTitle();
                                        beforeonload.refresh($scope);
                                        //  稿件加锁
                                        if (flag) {
                                            editIsLock.lockDraft($scope.status.meteDataId);
                                        }
                                        editCenUploadVideoForXjService.clearDraftVideoInfo('trill', $scope.status.routerArticleIdKey);
                                        defer.resolve(data);
                                    });
                                },
                                function () {
                                    defer.reject();
                                }
                            );
                        })
                        .error(function () {
                            editingCenterService.checkSaveError($scope.videoForm, $element, $scope);
                            defer.reject({
                                plat: '抖音'
                            });
                        });
                });
            }, () => {
                defer.reject({
                    plat: '抖音'
                });
            });
            return defer.promise;
        }

        /**
         * [处理标题-组合话题，处理表情等]
         */
        /**
         * [dealTitle description]
         * @return  {[type]}  [return description]
         */
        function dealTitle() {
            let str = '';
            angular.forEach($scope.data.topicList, function (topic) {
                if (topic.title !== '') {
                    str += '#' + topic.title + ' ';
                }
            });
            $scope.list.TITLE = str + $scope.list.TITLE;
            $scope.data.topicList = [];
        }

        /**
         * [trillTrial description]送审操作
         * @return {[type]} [description]
         */
        $scope.trillTrial = function () {
            newMediaService.trial($scope, $scope.data.trenchConst.trial).then((opinion) => {
                saveList().then(function () {
                    let trillParams = {
                        opinion: opinion
                    };
                    angular.extend(trillParams, $scope.operateParams, $scope.data.trenchConst.trial);
                    messagePublishService.publish('doEditPageOperation', trillParams);
                });
            });
        };

        /**
         * [trillKill description]撤稿操作
         * @return {[type]} [description]
         */
        $scope.trillKill = function () {
            newMediaService.rejection($scope, $scope.data.trenchConst.rejection).then((opinion) => {
                saveList().then(function () {
                    let KillParams = {
                        opinion: opinion
                    };
                    angular.extend(KillParams, $scope.operateParams, $scope.data.trenchConst.rejection);
                    messagePublishService.publish('doEditPageOperation', KillParams);
                });
            });
        };

        /**
         * [trillSign description]签发操作
         * @return {[type]} [description]
         */
        $scope.trillSign = $scope.loadingPromise = function () {
            $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.data.trenchConst.mediaType).then(
                function () {
                    newMediaService.sign($scope, $scope.data.trenchConst.sign).then(() => {
                        saveList().then(function () {
                            let signParams = {

                            };
                            angular.extend(signParams, $scope.operateParams, $scope.data.trenchConst.sign);
                            messagePublishService.publish('doEditPageOperation', signParams);
                        });
                    });
                }
            );
        };

        /**
         * [initOrigin description]初始化原创
         * @return {[type]} [description]
         */
        function initOrigin() {
            $scope.status.nopayment = true;
            for (var i = 0; i < $scope.data.originList.length; i++) {
                if ($scope.list.ORIGINALTYPE == $scope.data.originList[i].value) {
                    $scope.checkOrigin($scope.data.originList[i]);
                    break;
                }
            }
            $scope.data.specialDoc = $scope.list.SPECIALDOC;
        }
        // 原创声明
        $scope.oringin = function (list) {
            if (list.ORIGINAL === '1') {
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.list.ORIGINAL = '1';
                $scope.data.originType = $scope.data.originList[0].value;
                $scope.data.specialDoc = 0;
            }
            if (!$scope.status.nopayment) {
                $scope.status.nopayment = true;
                $scope.list.ISNOPAYMENT = '0';
            }
        };
        // 勾选原创稿二级单选的原创类型
        $scope.checkOrigin = function (item, type) {
            $('.newsResourcesTips')
                .find('.tips')
                .remove();
            $scope.data.originType = item.value;
            $scope.list.ORIGINAL = '1';
            $scope.data.specialDoc = 0;
            if (!$scope.status.nopayment && !!type) {
                $scope.status.nopayment = true;
                $scope.list.ISNOPAYMENT = '0';
            }
        };
        // 点击特殊稿
        $scope.specialDoc = function () {
            if ($scope.data.specialDoc == 1) {
                $scope.data.specialDoc = 0;
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.data.specialDoc = 1;
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            }
        };

        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.videoForm.$error) {
                errorArray.push(error);
            }
            $scope.status.videoFormError = $scope.status.videoFormError == undefined ? [] : $scope.status.videoFormError;
            if ($scope.status.videoFormError.length !== errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.videoFormError = errorArray;
            }
            return $scope.status.videoFormError; // 返回
        };

        // /**
        //  * [revise description]修订
        //  * @return  {[type]}  [return description]
        //  */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function () {
                    var params = {
                        MediaType: $scope.data.trenchConst.mediaType,
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**
         * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
         * @return  {[type]}  [return description]
         */
        function showVersion() {
            if ($scope.status.isFusionEditor) {
                getFusionVersion();
            } else {
                getVersion();
                // getPropagandaReview();
            }
        }

        /**
         * [getVersion description] 获取流程记录
         * @return  {[type]}  [return description]
         */
        function getVersion() {
            newMediaService.getVersion($scope.data.trenchConst.mediaType, $scope.status.meteDataId).then(function (data) {
                $scope.data.records = data;
            });
        }

        /**
         * [getVersion description] 获取融合编辑流程记录
         * @return {[type]} [description]
         */
        function getFusionVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime($scope.data.sourceDocId || $state.params.iwometadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getFusionVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            newMediaService.openPersonalVersionTime($state.params.iwometadataid, item);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function () {
            editingCenterService
                .closeWinow($scope.videoForm.$dirty)
                .then(
                    function () {
                        saveList().then(function () {
                            storageListenerService.addListenerToDraftChange();
                            // storageListenerService.addListenerToTrill('save');
                            editIsLock.normalLock($scope.status.meteDataId).then(function (data) {
                                window.close();
                            });
                        });
                    },
                    function () {
                        angular.isDefined($scope.status.meteDataId)
                            ? editIsLock.normalLock($scope.status.meteDataId).then(function (data) {
                                window.close();
                            }) : window.close();
                    }
                );
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: $scope.data.trenchConst.closeListenKey, saveLocal: false });
        }


        /**
         * [addTopic description] 添加话题
         * @return  {[type]}  [return description]
         */
        $scope.addTopic = function () {
            let topic = {
                title: '',
                id: 'dy_topic' + $scope.data.topicList.length + 1,
            };
            $scope.data.topicList.push(topic);
            $timeout(function () {
                document.getElementById(topic.id).focus();
            }, 0);
        };

        $scope.deleteTopic = function (index) {
            $scope.data.topicList.splice(index, 1);
        };

        $scope.calcuWordNum = function () {
            let topicLength = 0;
            angular.forEach($scope.data.topicList, function (topic) {
                topicLength += topic.title.length;
            });
            topicLength += $scope.data.topicList.length * 2;
            $scope.data.titleWordNum = topicLength + $scope.list ? $scope.list.TITLE.length : 0;
        };

        $scope.$watch('data.topicList', function (params) {
            return $scope.calcuWordNum();
        }, true);

        $scope.$watch('list.TITLE', function (params) {
            return $scope.calcuWordNum();
        });

        $scope.addEmoji = function (item) {
            $scope.list.TITLE += item.emoji;
        };

        /**
         * [addAddress description] 触发添加地点操作
         * @return  {[type]}  [return description]
         */
        $scope.addAddress = function () {
            $scope.status.isShowMap = !$scope.status.isShowMap;
        };

        /**
         * [confirmAddress 确认添加地点]
         * @param   {[type]}  address  [address description]
         * @return  {[type]}           [return description]
         */
        $scope.confirmAddress = function (address) {
            $scope.status.isShowMap = false;
            $scope.data.baiduLocation.poiId = address.POI_ID;
            $scope.data.baiduLocation.placeName = address.POI_NAME;
            $scope.status.isShowLocation = true;
        };

        /**
         * [cancelAddAddress description] 取消添加地点操作
         * @return  {[type]}  [return description]
         */
        $scope.cancelAddAddress = function () {
            $scope.status.isShowMap = false;
        };

        $scope.deleteLocation = function () {
            $scope.data.baiduLocation.placeName = '';
            $scope.data.baiduLocation.poiId = '';
            $scope.status.isShowLocation = false;
        };

        /**
         * [initLocation 初始化定位信息]
         * @return  {[type]}  [return description]
         */
        function initLocation() {
            if ($scope.list.POI_NAME && $scope.list.POI_NAME !== '') {
                $scope.data.baiduLocation.placeName = $scope.list.POI_NAME;
                $scope.status.isShowLocation = true;
            }
        }
    },
]);
